import React from 'react';
import { apiFetch } from '../api.js';

export function useApi(path, deps = []) {
  const [state, setState] = React.useState({
    loading: true,
    data: null,
    error: ''
  });

  React.useEffect(() => {
    let active = true;
    setState({ loading: true, data: null, error: '' });
    apiFetch(path)
      .then((data) => {
        if (!active) return;
        setState({ loading: false, data, error: '' });
      })
      .catch((err) => {
        if (!active) return;
        setState({ loading: false, data: null, error: err?.message || 'Request failed' });
      });
    return () => {
      active = false;
    };
  }, [path, ...deps]);

  return state;
}
